module.exports = __webpack_public_path__ + "static/Angular-Iphone-Still-e1346fb903a7c62132970d40a60e657d.jpg";